<template>
    <div>
        <b-form-group :label="field.label" :label-for="`id_${field._id}`">
            <div class="form-group">
                <date-time-picker
                    v-model="model"
                    v-validate="{
                        required: field.isRequired,
                    }"
                    date-format="DD/MM/YYYY"
                    :placeholder="
                        field.placeholder ? field.placeholder : 'DD / MM / YYYY'
                    "
                    format-val="DD/MM/YYYY"
                    date
                    close
                    no-footer
                    :data-vv-name="field._id"
                    :class="{
                        'is-invalid': errors.has(field._id),
                    }"
                    @input="onInput"
                ></date-time-picker>
            </div>
            <p v-if="note" class="tax-instruction">
                <i class="icon-error_outline"></i>
                <span>
                    {{ note }}
                </span>
            </p>
        </b-form-group>
    </div>
</template>

<script>
import DateTimePicker from '@/components/DateTimePicker.vue'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        DateTimePicker,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            required: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            model: null,
        }
    }, // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        /**
         *
         * @return {string}
         */
        note() {
            return this.field.note
        }, // End of note() method
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Handle when the value is updated
         *
         * @return {void}
         */
        onInput(newValue) {
            this.model = newValue
        }, // End of onSubmit() method
    }, // End of Component > methods
}
</script>
